module.exports = __webpack_public_path__ + "8d15f58bdbff5fe67ab02975070c6225.jpg";